import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
 /*if (environment.production) {
    enableProdMode();
   
  }*/
  // console.log('Modo de producción habilitado',!isDevMode() );

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));

